<template>
  <div class="iframe-container">
    <!--iframe
      :src="'https://dpd.talentprint.com/' + autoLoginToken"
      class="hidden"
    >
    </iframe-->
    <iframe
      :src="'https://gala.talentprint.com/planners/dash'+autoLoginToken"
      class="w-full h-full border-0"
    >
    </iframe>
  </div>
</template>

<script>
export default {
  name: "Main",
  created() {
    this.$store.commit("SET_PAGE_TYPE", "alex-connect");
    this.$store.commit("SET_PAGE_FOOTER_BACKGROUND_COLOR", "#F7F7F7");

  },
  computed: {
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    autoLoginToken() {

        return this.$store.state.boards.userBoardData.youlabToken;

    },
  },
  watch: {
    autoLoginToken() {
      if (this.isUserLoggedIn) {
        return this.$store.state.boards.userBoardData.youlabToken;
      }
    },
  },

};
</script>
<style scoped>
.iframe-container {
  height: 7700px;
  margin-top: 2rem;
}
</style>
